import React from 'react';
import { Tag } from './SuccessStoryDto';

const TagComponent: React.FC<Tag> = ({ icon, text, headlineType }) => {
    const CustomHeadingTag = headlineType as keyof JSX.IntrinsicElements;
    return (
        <div className="icon-tag">
            <span className="icon">
                <img src={icon.src} alt={icon.alt} />
            </span>
            {headlineType ? (
                <CustomHeadingTag className="icon-tag__text">{text}</CustomHeadingTag>
            ) : (
                <span className="icon-tag__text">{text}</span>
            )}
        </div>
    );
};

export default TagComponent;
